import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const lockPoll = (id, time) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.POLL_RESULT(id, time)
  );
};

export default lockPoll;
